export default __webpack_public_path__ + "static/media/cv.0e907c1b.pdf";